import { FormStore, GlobalStore } from "@roc/feature-app-core";
import { makeObservable } from "mobx";

const form = {
  fields: {
    rocInterestAccrued: {
      value: '',
      error: null,
      rule: '',
    },
    slsInterestAdditionalCharges: {
      value: '',
      error: null,
      rule: '',
    },
    rocLatePenalty: {
      value: '',
      error: null,
      rule: '',
    },
    slsPenaltyAdditionalCharges: {
      value: '',
      error: null,
      rule: '',
    },
    defaultPenalty: {
      value: '',
      error: null,
      rule: '',
    },
    defaultInterest: {
      value: '',
      error: null,
      rule: '',
    },
    maturityDefaultInterest: {
      value: '',
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class PayoffAdjustmentsFormStore extends FormStore {

  private globalStore: GlobalStore;

  constructor(globalStore: GlobalStore) {
    super({ ...form }, globalStore);
    makeObservable(this, {
    });
  }
}

export default PayoffAdjustmentsFormStore;